import React, { useEffect, useMemo, useState } from "react"
import { Button, Col, Divider, Flex, Form, Input, InputNumber, notification, Row, Select, Space, Upload, UploadFile } from "antd"

import { TypeViagem } from "../../../../../Models/Domain/Viagem/Viagem";
import { useForm, useWatch } from "antd/lib/form/Form";
import { QuestionCircleTwoTone, UploadOutlined } from "@ant-design/icons";
import { scrollarParaOElemento } from "../../../../../Utils/Navegacao";
import { useMutation, useQuery } from "@tanstack/react-query";
import { DestinoService } from "../../../../../Services/Domain/Viagem/DestinoService";
import { EscolaService } from "../../../../../Services/Domain/Pessoa/EscolaService";
import { StatusDaViagemService } from "../../../../../Services/Domain/Viagem/StatusDaViagemService";
import { TipoDeViagemService } from "../../../../../Services/Domain/Viagem/TipoDeViagemService";
import TextArea from "antd/es/input/TextArea";

import dayjs from "dayjs"

import { FormularioDePagamentos } from "../Componentes/FormularioDePagamentos";
import { TypeFormaDePagamentoDaViagem } from "../../../../../Models/Domain/Viagem/FormaDePagamentoDaViagem";
import { TypeLembreteDaViagem } from "../../../../../Models/Domain/Viagem/Lembrete";
import { FormularioDeLembretes } from "../Componentes/FormularioDeLembretes";
import { ViagemService } from "../../../../../Services/Domain/Viagem/ViagemService";
import { PropriedadesDeNotificacao } from "../../../../../Utils/Notificacoes";
import Arquivo from "../../../../../Models/Pessoa/Sistema/Arquivo";
import { Formatacoes } from "../../../../../Utils/Formatacao";
import ServicoServices from "../../../../../Services/Financeiro/Faturamento/ServicoServices";
import { CentroCustoService } from "../../../../../Services/Financeiro/CentroCustoService";
import PlanoDeContasSelect from "../../../../../Components/Populados/Financeiro/PlanoDeContas/PlanoDeContasSelect";
import EditorDrawer from "../../../../../Components/Base/CKEditor/EditorDrawer";
import { TypeCentroCusto } from "../../../../../Models/Financeiro/CentroCusto";
import { EnumCentroCustoTipo } from "../../../../../Models/Financeiro/CentroCustoTipo";
import EmpresaSelect from "../../../../../Components/Populados/Pessoa/Empresa/EmpresaSelect";
import { EnumPlanoContasTipoMovimentacao } from "../../../../../Models/Financeiro/PlanoContasTipo";
import { EnumRegistroTipo } from "../../../../../Models/Financeiro/PlanoContasTipoRegistro";
import InputDate from "../../../../../Components/Base/Input/InputDate";
import { SelectComPesquisa } from "@/Components/SelectComPesquisa";

export const CadastroDeViagens: React.FC<{
    aoCancelar?: () => any,
    depoisDeFinalizar?: (v?: TypeViagem) => any,
    viagemEmAlteracao?: TypeViagem
}> = (props) => {
    const ehAlteracao = (props.viagemEmAlteracao ?? null) != null;

    const [formularioDeDadosBasicos] = useForm<TypeViagem>();
    const valoresDoFormularioDeDadosBasicos = useWatch([], formularioDeDadosBasicos);
    const [ arquivosDoUploadDaMinuta, setArquivosDoUploadDaMinuta ] = useState<UploadFile[]>([])

    const IDs = {
        inicioDoFormularioDeDadosBasicos: "inicio-do-formulario-de-dados-basicos-da-viagem",
        inicioDoFormularioDePagamento: "inicio-do-formulario-de-dados-de-pagamento-da-viagem",
        inicioDoFormularioDeLembretes: "inicio-do-formulario-de-lembretes-da-viagem",
    }

    const estaEditando = useMemo(() => props.viagemEmAlteracao != undefined, [])

    const formasDePagamentoAPI = useState<TypeFormaDePagamentoDaViagem[]>(props.viagemEmAlteracao?.formasDePagamento ?? [])
    const lembretesAPI = useState<TypeLembreteDaViagem[]>(props.viagemEmAlteracao?.lembretes ?? [])

    useEffect(() => {
        formularioDeDadosBasicos.setFieldsValue({
            ...props.viagemEmAlteracao,

            fim: (() => {let l = Formatacoes.paraData(props.viagemEmAlteracao?.fim); return l ? dayjs(l) : undefined } )(),
            inicio: (() => {let l = Formatacoes.paraData(props.viagemEmAlteracao?.inicio); return l ? dayjs(l) : undefined } )(),
            dataDeCriacao: (() => {let l = Formatacoes.paraData(props.viagemEmAlteracao?.dataDeCriacao); return l ? dayjs(l) : undefined } )(),
            prazoDeInscricao: (() => {let l = Formatacoes.paraData(props.viagemEmAlteracao?.prazoDeInscricao); return l ? dayjs(l) : undefined } )(),
        })

        if(props.viagemEmAlteracao?.minuta){
            const minuta = props.viagemEmAlteracao?.minuta as Arquivo;
            setArquivosDoUploadDaMinuta([
                {
                    name: minuta.nomeOriginal,
                    uid: minuta.nome,
                    size: minuta.tamanho,
                    fileName: minuta.nome,
                    type: minuta.extensao,
                    preview: minuta.endereco,
                    url: `${minuta.endereco}/${minuta.nome}`,
                }
            ])
        }

    }, [])

    const destinosDisponiveis = useQuery({
        queryKey: ["listarDestinos"],
        queryFn: () => new DestinoService().listarDestinos({ ativo: true }),
        enabled: true,
    });

    const tiposDeViagensDisponiveis = useQuery({
        queryKey: ["listarTiposDeViagens"],
        queryFn: () => new TipoDeViagemService().listarTiposDeViagem({ ativo: true }),
        enabled: true,
    });

    const escolasDisponiveis = useQuery({
        queryKey: ["listarEscolas"],
        queryFn: () => new EscolaService().listar({}),
        enabled: true,
    });

    const statusDisponiveis = useQuery({
        queryKey: ["listarStatusDisponiveis"],
        queryFn: () => new StatusDaViagemService().listarStatusDisponiveis(),
        enabled: true,
    });

    const servicosDisponiveis = ServicoServices.useListar({});

    const centrosDeCustosDisponiveis = useQuery({
        queryKey: ["listarCentrosDeCustosDisponiveis"],
        queryFn: () => new CentroCustoService().listar({ ativo : true } as TypeCentroCusto),
        enabled: true,
    });

    const inserirViagem = useMutation({
        mutationKey: ["inserirViagem"],
        mutationFn: (payload: TypeViagem) => new ViagemService().inserirViagem(payload),
        onSuccess() {
            notification.open({
                ...PropriedadesDeNotificacao.Sucesso("Cadastro realizado com sucesso")
            });
            
            props.depoisDeFinalizar?.()
        },
    })

    const atualizarViagem = useMutation({
        mutationKey: ["atualizarViagem"],
        mutationFn: (payload: TypeViagem) => new ViagemService().atualizarViagem(payload),
        onSuccess(_, payload) {
            notification.open({
                ...PropriedadesDeNotificacao.Sucesso("Registro atualizado com sucesso")
            });

            props.depoisDeFinalizar?.(payload);
        },
    })

    const finalizar = async () => {
        return formularioDeDadosBasicos.validateFields()
            .then((dadosBasicos) => {
                let payload: TypeViagem = {
                    ...dadosBasicos,
                    lembretes: lembretesAPI[0],
                    formasDePagamento: formasDePagamentoAPI[0],
                    fim: Formatacoes.paraData(dadosBasicos.fim),
                    inicio: Formatacoes.paraData(dadosBasicos.inicio),
                    prazoDeInscricao: Formatacoes.paraData(dadosBasicos.prazoDeInscricao),
                }

                const estaEditando = props.viagemEmAlteracao != undefined;
                if(estaEditando){
                    payload = {...props.viagemEmAlteracao, ...payload} 
                    payload.codigo = props.viagemEmAlteracao?.codigo;
                    atualizarViagem.mutate(payload);
                } else {
                    payload.codigo = undefined;
                    inserirViagem.mutate(payload);
                }

            })
            .catch(() => {
                scrollarParaOElemento(document.getElementById(IDs.inicioDoFormularioDeDadosBasicos));
            })
    }

    return (
        <React.Fragment>
            <div>
                <span id={IDs.inicioDoFormularioDeDadosBasicos} />
                <Col span={24}>
                    <h3 style={{ marginTop: 0 }}>
                        Dados básicos <QuestionCircleTwoTone id={"Not implemented yet"} style={{ cursor: "pointer" }} onClick={() => {}} />
                    </h3>
                </Col>

                <Form form={formularioDeDadosBasicos} layout="vertical" autoComplete="off" validateTrigger="onBlur">
                    <Space size="small" direction="vertical">
                        <Row gutter={16}>
                            <Col xs={24} xl={8}>
                                <Form.Item<TypeViagem> name={["titulo"]} rules={[{ required: true, message: "Por favor, informe o título!" }]} label="Título">
                                    <Input placeholder="Informe o título" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} xl={8}>
                                <Form.Item<TypeViagem>
                                    name={["destino", "codigo"]}
                                    label="Destino"
                                    rules={[{ required: true, message: "Por favor, informe o destino!" }]}
                                >
                                    <SelectComPesquisa
                                        allowClear
                                        placeholder={"Selecione"}
                                        loading={destinosDisponiveis.isFetching}
                                        options={destinosDisponiveis.data?.data.map((item) => ({ value: item.codigo, label: item.nome }))}
                                    />
                                </Form.Item>
                            </Col>

                            <Col xs={24} xl={8}>
                                <Form.Item<TypeViagem>
                                    name={["escola", "codigo"]}
                                    label="Escola"
                                    rules={[{ required: true, message: "Por favor, informe a escola" }]}
                                >
                                    <SelectComPesquisa
                                        allowClear
                                        placeholder={"Selecione"}
                                        loading={escolasDisponiveis.isFetching}
                                        options={escolasDisponiveis.data?.data.map((item) => ({ value: item.codigo, label: item.pessoa?.nomeExibicao }))}
                                    />
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={6} lg={3}>
                                <Form.Item<TypeViagem>
                                    name={["quantidadeDeAlunos"]}
                                    label="Número de alunos"
                                    rules={[
                                        { required: true, message: "Por favor, informe o número de alunos!" },
                                        {
                                            validator: (_, value) => {
                                                if (value == undefined) return Promise.resolve();
                                                return value > 0 ? Promise.resolve() : Promise.reject("O número de alunos tem que ser maior que 0");
                                            },
                                        },
                                    ]}
                                >
                                    <InputNumber style={{ width: "100%" }} min={0} precision={0} controls={false} placeholder="Nenhum" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={5}>
                                <Form.Item<TypeViagem>
                                    name={["turma"]}
                                    label="Turma"
                                    rules={[{ required: true, message: "Por favor, informe o nome da turma!" }]}
                                >
                                    <Input placeholder="Informe o nome da turma" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} xl={4}>
                                <Form.Item<TypeViagem>
                                    name={["status", "codigo"]}
                                    label="Status"
                                    rules={[{ required: true, message: "Por favor, informe o status!" }]}
                                    initialValue={estaEditando ? undefined : 1}
                                >
                                    <Select
                                        allowClear
                                        placeholder={"Selecione"}
                                        options={statusDisponiveis.data?.data.map((item) => ({ value: item.codigo, label: item.descricao }))}
                                    />
                                </Form.Item>
                            </Col>

                            <Col xs={24} xl={4}>
                                <Form.Item<TypeViagem>
                                    name={["inicio"]}
                                    label="Início"
                                    rules={[
                                        { required: true, message: "Por favor, informe a data de início da viagem!" },
                                        {
                                            validator: (_, inicio: Date) => {
                                                const fim = Formatacoes.paraData(valoresDoFormularioDeDadosBasicos?.fim);
                                                if (inicio == undefined || fim == undefined) return Promise.resolve();

                                                if (inicio > fim) {
                                                    return Promise.reject("A data de início não pode ser posterior à data de término!");
                                                }

                                                return Promise.resolve();
                                            },
                                        },
                                    ]}
                                >
                                    <InputDate style={{ width: "100%" }} placeholder="Informe" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} xl={4}>
                                <Form.Item<TypeViagem>
                                    name={["fim"]}
                                    label="Término"
                                    rules={[{ required: true, message: "Por favor, informe a data de término da viagem!" }]}
                                >
                                    <InputDate style={{ width: "100%" }} placeholder="Informe" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} xl={4}>
                                <Form.Item<TypeViagem>
                                    name={["prazoDeInscricao"]}
                                    label="Prazo de inscrição"
                                    rules={[
                                        { required: true, message: "Por favor, informe a data de término da viagem!" },
                                        {
                                            validator: (_, prazo: Date) => {
                                                const fim = Formatacoes.paraData(valoresDoFormularioDeDadosBasicos?.fim);
                                                if (prazo == undefined || fim == undefined) return Promise.resolve();

                                                if (prazo > fim) {
                                                    return Promise.reject("O prazo não pode ser posterior à data de término!");
                                                }

                                                return Promise.resolve();
                                            },
                                        },
                                    ]}
                                >
                                    <InputDate style={{ width: "100%" }} placeholder="Informe" />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col xs={24} xl={5}>
                                <Form.Item<TypeViagem>
                                    name={["tipoDeViagem", "codigo"]}
                                    label="Tipo de viagem"
                                    rules={[{ required: true, message: "Por favor, selecione o tipo de viagem" }]}
                                >
                                    <Select
                                        allowClear
                                        loading={tiposDeViagensDisponiveis.isFetching}
                                        placeholder={"Selecione"}
                                        options={tiposDeViagensDisponiveis.data?.data.map((t) => ({ label: t.nome, value: t.codigo }))}
                                    />
                                </Form.Item>
                            </Col>

                            <Col xs={24} xl={4}>
                                <Form.Item<TypeViagem>
                                    name={["viagemAerea"]}
                                    label="É uma viagem aérea?"
                                    rules={[{ required: true, message: "Por favor, informe se é ou não uma viagem aérea!" }]}
                                >
                                    <Select
                                        allowClear
                                        placeholder={"Selecione"}
                                        options={[
                                            { value: true, label: "Sim" },
                                            { value: false, label: "Não" },
                                        ]}
                                    />
                                </Form.Item>
                            </Col>

                            <Col xs={24} xl={4}>
                                <Form.Item<TypeViagem>
                                    name={["requerFichaDeSaude"]}
                                    label="Requer ficha de saúde?"
                                    rules={[{ required: true, message: "Por favor, informe se requer ou não a ficha de saúde!" }]}
                                >
                                    <Select
                                        allowClear
                                        placeholder={"Selecione"}
                                        options={[
                                            { value: true, label: "Sim" },
                                            { value: false, label: "Não" },
                                        ]}
                                    />
                                </Form.Item>
                            </Col>

                            <Col xs={24} xl={5}>
                                <Form.Item<TypeViagem>
                                    name={["requerAutorizacaoParaMenores"]}
                                    label="Requer autorização de viagem?"
                                    rules={[{ required: true, message: "Por favor, informe se requer ou não a autorização" }]}
                                >
                                    <Select
                                        allowClear
                                        placeholder={"Selecione"}
                                        options={[
                                            { value: true, label: "Sim" },
                                            { value: false, label: "Não" },
                                        ]}
                                    />
                                </Form.Item>
                            </Col>

                            <Col xs={24} xl={4}>
                                <Form.Item<TypeViagem> name={["servico", "codigo"]} label="Serviço" rules={[]}>
                                    <Select
                                        allowClear
                                        placeholder={"Selecione"}
                                        loading={servicosDisponiveis.isFetching}
                                        options={servicosDisponiveis.data?.map((v) => ({
                                            label: v.nome,
                                            value: v.codigo,
                                        }))}
                                    />
                                </Form.Item>
                            </Col>

                            <Col xs={24} xl={2}>
                                <Form.Item<TypeViagem>
                                    name={["pago"]}
                                    label="Escola paga?"
                                    initialValue={estaEditando ? undefined : false}
                                    rules={[{ required: true, message: "Por favor, informe se a viagem já foi paga!" }]}
                                >
                                    <Select
                                        allowClear
                                        placeholder={"Selecione"}
                                        options={[
                                            { value: true, label: "Sim" },
                                            { value: false, label: "Não" },
                                        ]}
                                    />
                                </Form.Item>
                            </Col>

                            <Col xs={24} xl={4}>
                                <Form.Item<TypeViagem>
                                    name={["alunosInformados"]}
                                    label="Alunos informados?"
                                    initialValue={estaEditando ? undefined : false}
                                    rules={[{ required: true, message: "Por favor, informe se os alunos são informados!" }]}
                                >
                                    <Select
                                        allowClear
                                        placeholder={"Selecione"}
                                        options={[
                                            { value: true, label: "Sim" },
                                            { value: false, label: "Não" },
                                        ]}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col xs={24} xl={8}>
                                <Form.Item<TypeViagem>
                                    name={["senha"]}
                                    label="Senha"
                                    initialValue={estaEditando ? undefined : ""}
                                    rules={[{ required: true, message: "Por favor, informe a senha da viagem!" }]}
                                >
                                    <Input placeholder="Senha" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} xl={8}>
                                <Form.Item<TypeViagem>
                                    name={["centroDeCusto", "codigo"]}
                                    initialValue={-1}
                                    label="Centro de custo"
                                    rules={[
                                        {
                                            required: true,
                                        },
                                    ]}
                                >
                                    <SelectComPesquisa
                                        allowClear
                                        placeholder={"Selecione"}
                                        loading={centrosDeCustosDisponiveis.isFetching}
                                        options={[
                                            {
                                                descricao: "Cria centro de custo",
                                                codigo: -1,
                                                tipo: { codigo: ehAlteracao ? EnumCentroCustoTipo.GRUPO : EnumCentroCustoTipo.ITEM },
                                            },
                                            ...(centrosDeCustosDisponiveis.data?.data ?? []),
                                        ]
                                            .filter((f) => f.tipo?.codigo == EnumCentroCustoTipo.ITEM)
                                            .map((v) => ({
                                                label: v.descricao,
                                                value: v.codigo,
                                            }))}
                                    />
                                </Form.Item>
                            </Col>

                            <Col xs={24} xl={8}>
                                <Form.Item<TypeViagem>
                                    name={["planoDeContas"]}
                                    label="Plano de contas das inscrições"
                                    rules={[
                                        {
                                            required: true,
                                        },
                                    ]}
                                >
                                    <PlanoDeContasSelect
                                        filtros={{
                                            tipo: {
                                                codigo: EnumPlanoContasTipoMovimentacao.Receita,
                                            },
                                            tipoRegistro: {
                                                codigo: EnumRegistroTipo.Item,
                                            },
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24}>
                                <Form.Item label="Link de apresentação" name={["linkApresentacao"]}>
                                    <Input maxLength={500} placeholder="https://site.com.br?viagem=123" />
                                </Form.Item>
                            </Col>
                            {!ehAlteracao && (
                                <Col xs={24}>
                                    <Form.Item<TypeViagem> shouldUpdate={(anterior, atual) => anterior.centroDeCusto?.codigo != atual.centroDeCusto?.codigo}>
                                        {({ getFieldValue }) => {
                                            if (getFieldValue(["centroDeCusto", "codigo"]) === -1)
                                                return (
                                                    <Row gutter={16}>
                                                        <Divider orientation="left">Cadastro do centro de custo da viagem</Divider>
                                                        <Col xs={24} xl={8}>
                                                            <Form.Item<TypeViagem>
                                                                name={["centroDeCusto", "empresa", "codigo"]}
                                                                label="Empresa"
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                    },
                                                                ]}
                                                            >
                                                                <EmpresaSelect />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col xs={24} xl={8}>
                                                            <Form.Item<TypeViagem> name={["centroDeCusto", "grupo", "codigo"]} label="Grupo" rules={[]}>
                                                                <Select
                                                                    allowClear
                                                                    placeholder={"Selecione"}
                                                                    loading={centrosDeCustosDisponiveis.isFetching}
                                                                    options={(centrosDeCustosDisponiveis.data?.data ?? [])
                                                                        .filter((f) => f.tipo?.codigo == EnumCentroCustoTipo.GRUPO)
                                                                        .map((v) => ({
                                                                            label: v.descricao,
                                                                            value: v.codigo,
                                                                        }))}
                                                                />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                );
                                        }}
                                    </Form.Item>
                                </Col>
                            )}
                        </Row>

                        <Row gutter={16}>
                            <Col xs={24}>
                                <Form.Item<TypeViagem> name={"descricao"} label={"Descrição"} rules={[]}>
                                    <EditorDrawer
                                        elementoGatilho={
                                            <Button type="dashed" style={{ textWrap: "wrap", height: "fit-content" }}>
                                                Clique aqui para visualizar ou editar a descrição da viagem
                                            </Button>
                                        }
                                    />
                                </Form.Item>
                            </Col>

                            <Col xs={24}>
                                <Form.Item<TypeViagem>
                                    name={"observacoes"}
                                    label={"Observações"}
                                    rules={[{ max: 500, validateTrigger: "onChange", message: "As observações não podem ser superiores a 500 caracteres" }]}
                                >
                                    <TextArea
                                        placeholder="Id aliquip exercitation exercitation laboris ad ut eiusmod nulla aliquip sint."
                                        style={{ resize: "none" }}
                                        rows={4}
                                        count={{ show: true, max: 500 }}
                                    />
                                </Form.Item>
                            </Col>

                            <Col xs={24}>
                                <Form.Item<TypeViagem> label="Minuta da viagem" name={["minuta"]} getValueFromEvent={(p) => p.file}>
                                    <Upload
                                        maxCount={1}
                                        beforeUpload={(file, fileList) => false}
                                        multiple={false}
                                        listType="picture"
                                        fileList={arquivosDoUploadDaMinuta}
                                        showUploadList={{ previewIcon: true }}
                                        onChange={(info) => {
                                            setArquivosDoUploadDaMinuta(info.fileList);
                                        }}
                                        onRemove={(file) => {
                                            setArquivosDoUploadDaMinuta((prev) => prev.filter((f) => f.uid != file.uid));
                                        }}
                                    >
                                        <Button icon={<UploadOutlined />}>Carregar arquivo</Button>
                                    </Upload>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Space>
                </Form>

                <Divider />

                <span id={IDs.inicioDoFormularioDePagamento} />
                <Col span={24}>
                    <h3 style={{ marginTop: 0 }}>
                        Dados de pagamento <QuestionCircleTwoTone id={"Not implemented yet"} style={{ cursor: "pointer" }} onClick={() => {}} />
                    </h3>
                </Col>

                <FormularioDePagamentos formasDePagamentoAPI={formasDePagamentoAPI} permitirEdicao />

                <Divider style={{ marginTop: 0 }} />

                <span id={IDs.inicioDoFormularioDeLembretes} />
                <Col span={24}>
                    <h3 style={{ marginTop: 0 }}>
                        Lembretes <QuestionCircleTwoTone id={"Not implemented yet"} style={{ cursor: "pointer" }} onClick={() => {}} />
                    </h3>
                </Col>

                <FormularioDeLembretes lembretesAPI={lembretesAPI} permitirEdicao />

                <Divider />

                <Row gutter={16}>
                    <Col span={24}>
                        <Flex align="center" justify="center" gap={16}>
                            {props.aoCancelar && (
                                <Button
                                    danger
                                    type="primary"
                                    key={"cancel"}
                                    onClick={() => {
                                        props.aoCancelar && props.aoCancelar();
                                    }}
                                >
                                    Cancelar
                                </Button>
                            )}
                            <Button type="primary" key={"submit"} disabled={atualizarViagem.isPending || inserirViagem.isPending} onClick={finalizar}>
                                Salvar
                            </Button>
                        </Flex>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    );
}

export default CadastroDeViagens
